import type { StagedFile } from "@/features/self/personal-sheet";
import type { PersonalSheet } from "../types/personalSheet";

function findStagedUrl(uploadedFiles: StagedFile[], section: string, token: string | undefined, field: string): string | null {
  if (!token) return null;
  const match = uploadedFiles.find((file) => file.field_name === `${section}.${token}.${field}`);
  return match?.url ?? null;
}

export function enrichDraftFilesFromStaged(data: PersonalSheet, uploadedFiles: StagedFile[]): PersonalSheet {
  return {
    ...data,
    education: data.education.map((entry) => ({
      ...entry,
      diploma_file_url:
        findStagedUrl(uploadedFiles, "education", entry.diploma_file_token, "diploma_file") ?? entry.diploma_file_url ?? null,
      diploma_transcript_file_url:
        findStagedUrl(uploadedFiles, "education", entry.diploma_transcript_file_token, "diploma_transcript_file") ??
        entry.diploma_transcript_file_url ??
        null,
    })),
    scientific_works: data.scientific_works.map((entry) => ({
      ...entry,
      file_url: findStagedUrl(uploadedFiles, "scientific_works", entry.file_token, "file") ?? entry.file_url ?? null,
    })),
    social_categories: data.social_categories.map((entry) => ({
      ...entry,
      document_file_url:
        findStagedUrl(uploadedFiles, "social_categories", entry.document_file_token, "document_file") ??
        entry.document_file_url ??
        null,
    })),
  };
}
